import React, { Fragment } from 'react';
import map from 'lodash/map';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import FormInputLabel from './form_input_label.jsx';
import SiteViewerVersionComponentSelector from 'zoomforth_codesbane_viewer/component_lib/site_viewer_version_component_selector_container.jsx';
import { radioQuestionPropType } from './prop_types.js';
import { preventEnterKeyDownSubmit } from './form.jsx';
import { CheckCircleIcon, WarningIcon } from 'zoomforth_component_lib/external_modern_icons.jsx';

export const FormRadioInput_ViewerVersion2 = ({
  question,
  formValue,
  uniqueFormString,
  onQuestionChange
}) => (
  <fieldset>
    <legend>
      <FormInputLabel {...{ question, formValue, uniqueFormString, isFieldsetLabel: true }} />
    </legend>
    <div className="form-input form-option-inputs">
      {map(question.content.options, (option, index) => (
        <div
          className={classnames(
            'form-option-input-container',
            formValue.value === option.label ? 'form-option-input-selected' : 'form-option-input-deselected'
          )}
          key={`${question.name}-${index}`}
        >
          <span className="form-option-input">
            <input
              aria-describedby={question.isRequired ? null : 'optional-description'}
              id={`${question.name}-${uniqueFormString}-${index}`}
              type="radio"
              name={question.name}
              value={option.label}
              onChange={(e) => { onQuestionChange(question, e.target.value); }}
              onKeyDown={preventEnterKeyDownSubmit}
            />
          </span>
          <label htmlFor={`${question.name}-${uniqueFormString}-${index}`} className="form-option-input-label">
            {option.label}
          </label>
        </div>
      ))}
      <span className="form-input-status-icon-container">
        {formValue.error ?
          <WarningIcon className="form-input-status-icon" />
          :
          <CheckCircleIcon className="form-input-status-icon" />
        }

      </span>
      <div className="form-input-error">
        <p className="form-input-error-text">Please fill in this field.</p>
      </div>
    </div>
  </fieldset>
);

FormRadioInput_ViewerVersion2.propTypes = {
  question: radioQuestionPropType.isRequired,
  onQuestionChange: PropTypes.func.isRequired,
  onQuestionTouch: PropTypes.func.isRequired
};

export const FormRadioInput_ViewerVersion1 = ({
  question,
  onQuestionChange
}) => (
  <Fragment>
    <label className="form-field-label">
      {question.label} {question.isRequired && <span className="form-field-required-indicator">*</span>}
    </label>
    {map(question.content.options, (option, index) => (
      <div
        className="form-field-container"
        key={`${question.name}-${index}`}
      >
        <span className="form-field-radio-container">
          <input
            id={`${question.name}-${index}`}
            className="form-field-radio"
            type="radio"
            name={question.name}
            value={option.label}
            onChange={(e) => onQuestionChange(question, e.target.value)}
            onKeyDown={preventEnterKeyDownSubmit}
          />
        </span>
        <label htmlFor={`${question.name}-${index}`} className="form-field-option-label">
          {option.label}
        </label>
      </div>
    ))

    }
  </Fragment>
);

FormRadioInput_ViewerVersion1.propTypes = {
  question: radioQuestionPropType.isRequired,
  onQuestionChange: PropTypes.func.isRequired,
  onQuestionTouch: PropTypes.func.isRequired
};

const FormRadioInput = (props) => (
  <SiteViewerVersionComponentSelector>
    <FormRadioInput_ViewerVersion1 forSiteViewerVersion={1} {...props} />
    <FormRadioInput_ViewerVersion2 forSiteViewerVersion={2} {...props} />
  </SiteViewerVersionComponentSelector>
);

export default FormRadioInput;